import * as React from 'react';
import { GoogleMapsJson, Marker } from '../empracoTypes';
import { ErrorWindow } from '../generic/elements';
import GoogleMapReact from 'google-map-react';
import { FaIcon } from '../generic/icon';

export interface GoogleMapsProps {
  model: GoogleMapsJson;
}

export default function GoogleMaps (props: GoogleMapsProps) {
  const { model } = props;

  if (!model.apiKey && !model.iframeHtml) {
    return <ErrorWindow
      message={'You have to specify either a valid Google Maps Api key or an embedded iframe HTML string.'} />;
  }

  if (model.iframeHtml) {
    return <div className='empori-maps-iframe'
      dangerouslySetInnerHTML={{ __html: model.iframeHtml}}></div>;
  }

  const defaultProps = {
    center: {
      lat: model.initialLat,
      lng: model.initialLng
    },
    zoom: model.initialZoom
  };

  const style = {
    height: model.height,
    width: '100%'
  };

  return(
    <div className='empori-google-maps' style={style}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: model.apiKey }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}>
        {model.markerCollection && model.markerCollection.markers.map((marker, index) =>
          <MapMarker {...marker} key={`map-marker-${index}`} />)}
      </GoogleMapReact>
    </div>
  );
};

function MapMarker (props: Marker) {
  return <div className='empori-map-marker' title={props.address}>
    <div className='empori-map-marker-info'>
      <strong>{props.address}</strong>
      {props.description && props.description}
    </div>
    <FaIcon clsName='fa-solid fa-location-pin' />
  </div>;
}